import { marginTop, pxToRem, Table, themeGet, Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTable = styled(Table) `
  ${marginTop(7)};
`;
export const StyledTypography = styled(Typography) `
  ${props => (props === null || props === void 0 ? void 0 : props.$uppercase) && `text-transform: uppercase;`}
  white-space: nowrap;
`;
export const Divider = styled.div `
  display: flex;
  width: 0;
  height: 2rem;
  border-left: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
`;
